import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getBaseURL } from '../../services/api';
import './FeedbackPage.css';

const UnsubscribePage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Token mancante.');
      return;
    }
    fetch(`${getBaseURL()}/public/marketing/unsubscribe?token=${encodeURIComponent(token)}`, {
      method: 'POST',
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data.error || 'Operazione non riuscita');
        }
        setStatus('ok');
        setMessage(data.message || 'Iscrizione annullata.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'Errore');
      });
  }, [token]);

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-card">
        <h1>Virtual Clinic</h1>
        {status === 'loading' && <p>Elaborazione…</p>}
        {status === 'ok' && <p>{message}</p>}
        {status === 'error' && <p className="feedback-error">{message}</p>}
      </div>
    </div>
  );
};

export default UnsubscribePage;
